export const AREA_CACHE = '/v1/area/cache/'